import { useStaticQuery, graphql } from 'gatsby'

export function useGPUInstanceNav() {
  const {
    allStackNav: { nodes },
  } = useStaticQuery(
    graphql`
      query GPUInstanceNavQuery {
        allStackNav {
          nodes {
            groupName
            entries {
              id
              title
            }
          }
        }
      }
    `,
  )

  return nodes
}
